import React from 'react';
function TypeClean({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.309 4H19.8v2.965M6.6 19.812h5.7M11.077 13.459l-1.708 5.967M13.461 4.153l-1.217 5.102M4.151 7.867a.013.013 0 01.017-.019l13.156 10.695a.025.025 0 00.034-.038"
      />
    </svg>
  );
}

export default TypeClean;
